module.exports = __webpack_public_path__ + "static/img/kjdy01.770b6b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/kjdy01.jpg
// module id = 1414
// module chunks = 0